<div class="rs-card">

  <!-- Header -->
  <h3 class="rs-title">Overall Test Result Summary</h3>

  <!-- Doughnut Chart -->
  <div class="rs-chart-wrapper">
    <app-pie-chart
      [chartType]="'doughnut'"
      [isLoading]="isLoading"
      [data]="chartData"
      [backgroundColors]="chartMeta.backgroundColors"
      [meta]="chartMeta">
    </app-pie-chart>
  </div>

  <!-- Stat Cards Grid — Skeleton -->
  <div *ngIf="isLoading" class="rs-grid placeholder-glow">
    <div *ngFor="let i of [0,1,2,3]" class="rs-stat-card">
      <span class="rs-icon">
        <span class="placeholder rounded-circle" style="width:28px;height:28px;display:block;"></span>
      </span>
      <span class="rs-info">
        <span class="placeholder col-4 d-block mb-1" style="height:16px;"></span>
        <span class="placeholder col-6 d-block" style="height:12px;"></span>
      </span>
      <span class="placeholder ms-auto" style="width:36px;height:14px;display:block;"></span>
    </div>
  </div>

  <!-- Stat Cards Grid — Data -->
  <div *ngIf="!isLoading" class="rs-grid">
    <div
      *ngFor="let card of statCards"
      class="rs-stat-card"
      [ngClass]="card.cssClass">

      <span class="rs-icon">
        <img [src]="card.icon" [alt]="card.label" />
      </span>

      <span class="rs-info">
        <span class="rs-count">{{ getCount(card.key) }}</span>
        <span class="rs-label">{{ card.label }}</span>
      </span>

      <span class="rs-percent">{{ getPercent(getCount(card.key)) }}%</span>

    </div>
  </div>

</div>
